import * as Yup from "yup";
import { ProgramTemplateSearchFormKey } from "./Models"; 
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { specialCharactersNotAllowedValidationForOptionalField } from "../../../helpers/constants/commonValidationSchemaUtils";

export const SearchProgramTemplateSchema = (commonValidationMessages: KeyValueMap) => Yup.object().shape({
  [ProgramTemplateSearchFormKey.programTemplateName]: specialCharactersNotAllowedValidationForOptionalField(
      commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
    )
    .default(""),
  [ProgramTemplateSearchFormKey.programTemplateNameFilter]:
    Yup.string().default(""),
  [ProgramTemplateSearchFormKey.lineOfBusiness]: Yup.string().default(""),
  [ProgramTemplateSearchFormKey.programFrameWork]: Yup.string().default(""),
  [ProgramTemplateSearchFormKey.status]: Yup.string().default(""),
  [ProgramTemplateSearchFormKey.country]: Yup.array().default([]),
});
